import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';

// core components
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import GridItem from "../../../views/GridItem";
import GridContainer from "../../../views/GridContainer";
import Table from "../../../views/Table";
import Card from "../../../views/Card";
import CardHeader from "../../../views/CardHeader";
import CardBody from "../../../views/CardBody";
import { withSnackbar } from 'notistack';
import { styles } from './styles';
import ConfirmDialog from './ConfirmDialog'
import Apis from '../../../../utils/Apis'
import Workbook from 'react-excel-workbook'
import moment from 'moment-timezone'


class SafetyInfomation extends Component {
    state = {
        safetyInfomation_count: 0,
        pageNumber: 1,
        safetyInfomation: [],
        temp_page: [],
        export_safetyInfomation: [],
        isLoading: false,
        open_register: false,
    }

    componentWillMount() {
        const { pageNumber } = this.state;
        this.safetyInfomation(pageNumber);
    }
    getDate = (date_time) => {
        let date = moment(date_time).local().format("YYYY-MM-DD hh:mm A");
        return date;//date_time.substring(0, 10);
    }
    safetyInfomation = async (pageNumber) => {
        this.setState({ isLoading: true });
        try {
            let response = await Apis.getRecordInformation();
            let safetyInfomation = response.data;

            safetyInfomation = safetyInfomation.sort(
                (a, b) =>
                    moment(b.date).valueOf() - moment(a.date).valueOf()
            )

            const { classes } = this.props;
            let temp = [];
            let temp_safetyInfomation = [];
            var index = 0;
            for (let i = 0; i < safetyInfomation.length; i++) {
                let name = safetyInfomation[i]['worker_name'];
                let date = this.getDate(safetyInfomation[i]['date']);
                let info = name + ' has read Health & Safety Instruction at ' + date
                temp = [...temp,
                [

                    <Typography noWrap className={classes.typographyContent}>{i + 1}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{info}</Typography>,
                ]
                ];
                temp_safetyInfomation = [
                    ...temp_safetyInfomation,
                    {No: i + 1, 'Read Info': info}
                ];
            }
            const { pageNumber } = this.state;
            let temp_page = [];
            temp_page = temp;
            this.setState({ pageNumber: pageNumber, isLoading: false, safetyInfomation_count: safetyInfomation.length, safetyInfomation: temp, temp_page: temp_page, export_safetyInfomation: temp_safetyInfomation })


        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.setState({ isLoading: false });
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }
    
    // action for pagination
    handleChangePage = (event, page) => {
        const { pageNumber, safetyInfomation } = this.state;
        this.setState({
            pageNumber: page + 1,
        });
    }
    render() {
        const { classes } = this.props;
        const { safetyInfomation_count, pageNumber, temp_page, isLoading, export_safetyInfomation } = this.state;
        return (
            <div container>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>Safety Information</h4>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="black"
                                    tableHead={[<b>No</b>, <b>Read Info</b>]}
                                    tableData={temp_page}
                                    handleChangePage={this.handleChangePage}
                                    containerHeight={620}
                                    totalCount={temp_page.length}
                                    rowsPerPage={10}
                                    page={pageNumber}
                                    isLoading={isLoading}
                                />
                                <Grid container xs={12} sm={12} md={12}>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={11}>
                                    </Grid>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={1}>
                                        <Workbook filename="safetyInformation.xlsx" element={<Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple>Export</Button>}>
                                            <Workbook.Sheet data={export_safetyInfomation} name="Sheet A">
                                                <Workbook.Column label="No" value="No" />
                                                <Workbook.Column label="Read Info" value="Read Info" />
                                            </Workbook.Sheet>
                                        </Workbook>
                                    </Grid>
                                    
                                </Grid>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

SafetyInfomation.propTypes = {
    classes: PropTypes.object.isRequired
};

let mapStateToProps = (state) => {
    return {
        email: state.auth.email,
        requesting: state.auth.requesting,
    };
}
export default withStyles(styles)(connect(mapStateToProps, null)(withSnackbar(SafetyInfomation)));
